import api from 'base/utils/api';
import { IShort, IShortList } from 'base/interfacesV2/share'

/**
 * 通过长链接获取短链接
 * @param url
 */
export function getLongToShortUrl(url: string,): Promise<IShort> {
    return api.post('/web/share/long-to-short-url', {
        data: {
            url: url,
        }
    });
}

/**
 * 批量通过长链接获取短链接
 * @param urlList
 */
export function getBatchLongToShortUrl(urlList: string[]): Promise<IShortList> {
    return api.post('/web/share/batch-long-to-short-url', {
        data: {
            urlList: urlList,
        }
    });
}